/**
 * Created by istvan.rozsa on 2017. 04. 25..
 */
import sendEmailFactory from './send-email-factory';
import inputHasErrorFactory from '../../../utils/validation/input-has-error';
import ArrayUtils from '../../../utils/array-utils.js';

export default function SendEmailController(COMMON_CONSTS, DOCUMENT_TYPE, $filter, frameContext, EndPointProtection) {
	var ctrl = this;
	EndPointProtection.registerEndpointParams('sendDocumentImage', 60, 10);
	ctrl.COMMON_CONSTS = COMMON_CONSTS;
	ctrl.sendEmailModel = {
		toEmailTags: ctrl.partnerPrimaryContactEmail || []
	};
	ctrl.hasPreviewFunction = angular.isDefined(ctrl.goBackToPreview);
	ctrl.options = {
		title: '',
		subject: '',
		requiredModel: {
			subjectIsRequired: true,
			messageIsRequired: true
		},
		isTagsInput: true
	};
	ctrl.sendEmailFactory = sendEmailFactory(COMMON_CONSTS, DOCUMENT_TYPE, $filter);
	ctrl.inputHasError = inputHasErrorFactory;
	ctrl.frameContext = frameContext;
	ctrl.availableLanguages = ['HUN', 'ENG', 'GER'];

	function formatEmailTags(emailTagsObj) {
		var emailAddress = '';

		for (var i = 0; i < emailTagsObj.length; i++) {
			emailAddress = emailAddress.concat(emailTagsObj[i].text + ', ');
		}
		emailAddress = emailAddress.replace(/, $/, '');

		return emailAddress;
	}

	ctrl.submitForm = function () {
		if (ctrl.sendEmailForm.$valid) {
			if (ctrl.options.isTagsInput) {
				EndPointProtection.registerEndpointUsage('sendDocumentImage');
				ctrl.sendEmailModel.toEmail = formatEmailTags(ctrl.sendEmailModel.toEmailTags);
			}
			ctrl.sendEmailSubmit({sendEmailForm: ctrl.sendEmailForm, sendEmailModel: ctrl.sendEmailModel});
		}
	};

	ctrl.cancel = function () {
		ctrl.cancelCallback({sendEmailForm: ctrl.sendEmailForm, sendEmailModel: ctrl.sendEmailModel});
	};

	ctrl.goBackToPreviewWithEmailData = function () {
		ctrl.goBackToPreview({sendEmailModel: ctrl.sendEmailModel});
	};

	function pushPrimaryContactEmail(primaryContactEmail) {
		if (ctrl.sendEmailForm) {
			if (ctrl.sendEmailModel.hasOwnProperty('toEmailTags') && ctrl.sendEmailModel.toEmailTags.length > 10) {
				ctrl.sendEmailForm.$setValidity('tooMuchMailAddresses', true);
			} else {
				ctrl.sendEmailForm.$setValidity('tooMuchMailAddresses', false);
			}
		}

		ctrl.sendEmailModel = ctrl.sendEmailModel || {};

		if (ctrl.sendEmailModel.toEmailTags) {
			ctrl.sendEmailModel.toEmailTags
				.filter(email => email.text != primaryContactEmail)
				.concat([{text: primaryContactEmail}]);
		} else {
			ctrl.sendEmailModel.toEmailTags = [];
		}
	}

	ctrl.$onInit = function () {
		let messagePlaceHolders = {};
		ctrl.sendEmailFactory.setFormOptions(ctrl.options, ctrl.selectedDetailsTab, ctrl.docName);
		if (ctrl.copyOfEmailData) {
			ctrl.sendEmailModel = angular.copy(ctrl.copyOfEmailData);
			ctrl.sendEmailModel.toEmailTags = ctrl.partnerEmails || [];
		} else {
			ctrl.sendEmailModel.subject = ctrl.options.subject;
			messagePlaceHolders.invoiceNumber = ctrl.docid;
			messagePlaceHolders.userName = ctrl.frameContext.user_profile.fullname;

			const relId = ctrl.frameContext.user_profile.defaultRelationshipId;
			const relations = ctrl.frameContext.relations;
			messagePlaceHolders.companyName = ArrayUtils.filterByKeyValue(relations, 'RelationshipId', relId)[0].IdentityOriginalName;

			ctrl.sendEmailModel.message = $filter('placeHolder')(ctrl.options.body, messagePlaceHolders);
		}
	};

	ctrl.$onChanges = function (changes) {
		if (changes.partnerPrimaryContactEmail && changes.partnerPrimaryContactEmail.currentValue) {
			if (changes.partnerPrimaryContactEmail.currentValue.length) {
				changes.partnerPrimaryContactEmail.currentValue.forEach(function (mail) {
					pushPrimaryContactEmail(mail);
				});
			} else {
				pushPrimaryContactEmail(changes.partnerPrimaryContactEmail.currentValue);
			}
		}
	};
}
